import React from "react";
import PropTypes from "prop-types";
import styles from "components/settings/billing-details.scss";
// import { NoBillingDetails } from "components/settings/no-billing-details";
// import { billingDetailsType } from "custom-prop-types";

export const BillingDetails = () => (
  <div className={ styles.construction }>
    <h1>This page is still under construction.</h1>
    <h3>Please call us on 1300 00 1333 (AUS) or 0508 00 1333 (NZ) to update your billing details</h3>
  </div>
);

BillingDetails.propTypes = {
  accountId: PropTypes.string.isRequired,
  onRedirectToBilling: PropTypes.func.isRequired
};

// TODO: This is a temporary fix until the recurly.js library is implemented for PCI compliance
// export const BillingDetails = ({
//   accountId,
//   billingDetails,
//   isNoBillingDetails,
//   onSaveBillingDetails,
//   onUpdateBillingDetails,
//   slug
// }) => {
//   if (isNoBillingDetails) {
//     return <NoBillingDetails slug={ slug } />;
//   }
//   return (
//     <div>
//       <h1>Billing Details</h1>
//       <div className={ styles["card-form"] }>
//         <div className={ styles["form-title"] }>
//           <h2>Update Credit Card</h2>
//         </div>
//         { renderFormElement("First Name", billingDetails.name, onUpdateBillingDetails, "name") }
//         { renderFormElement("Last Name", billingDetails.surname, onUpdateBillingDetails, "surname") }
//         { renderFormElement(
//           "Card Number",
//           creditCardValue(billingDetails.cardNumber, billingDetails.lastFourDigits),
//           onUpdateBillingDetails,
//           "cardNumber"
//         ) }
//         <div className={ styles["field-cell"] }>
//           <div className={ styles["small-field"] }>
//             <div>Expiration</div>
//             <input
//               className={ `${styles.fields} ${styles.expiration}` }
//               maxLength={ "2" }
//               onChange={ (e) => { onUpdateBillingDetails("expiryMonth", e.target.value); } }
//               onFocus={ (e) => e.target.select() }
//               placeholder={ "MM" }
//               value={ billingDetails.expiryMonth }
//             />
//             <input
//               className={ `${styles.fields} ${styles.expiration} ${styles["expiration-right"]}` }
//               maxLength={ "4" }
//               onChange={ (e) => { onUpdateBillingDetails("expiryYear", e.target.value); } }
//               onFocus={ (e) => e.target.select() }
//               placeholder={ "YYYY" }
//               value={ billingDetails.expiryYear }
//             />
//           </div>
//           <div className={ styles["small-field"] }>
//             <div>Security Code</div>
//             <input
//               className={ `${styles.fields} ${styles.cvv}` }
//               maxLength={ "4" }
//               onChange={ (e) => { onUpdateBillingDetails("verificationValue", e.target.value); } }
//               onFocus={ (e) => e.target.select() }
//               placeholder={ "CVV" }
//             />
//           </div>
//         </div>
// { renderFormElement("Postcode", billingDetails.postcode, onUpdateBillingDetails, "postcode", "Your postcode") }
//         <div className={ `${styles.button} ${styles["field-cell"]}` }>
//           <Button
//             onClick={ () => onSaveBillingDetails(accountId, billingDetails) }
//             primary
//           >
//             Save Credit Card Details
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// BillingDetails.defaultProps = {
//   billingDetails: null
// };

// BillingDetails.propTypes = {
//   accountId: PropTypes.string.isRequired,
//   billingDetails: billingDetailsType,
//   isNoBillingDetails: PropTypes.bool.isRequired,
//   onSaveBillingDetails: PropTypes.func.isRequired,
//   onUpdateBillingDetails: PropTypes.func.isRequired,
//   slug: PropTypes.string.isRequired
// };

// const creditCardValue = (value, lastFourDigits) => {
//   if (value === null || value === undefined) {
//     return `XXXX XXXX XXXX ${lastFourDigits}`;
//   }
//   return value;
// };

// const renderFormElement = (title, value, onUpdateBillingDetails, fieldName, placeholder) => (
//   <div className={ styles["field-cell"] }>
//     <div>{ title }</div>
//     <input
//       className={ styles.fields }
//       onChange={ (e) => { onUpdateBillingDetails(fieldName, e.target.value); } }
//       onFocus={ (e) => e.target.select() }
//       placeholder={ placeholder }
//       type="text"
//       value={ value }
//     />
//   </div>
// );



// WEBPACK FOOTER //
// ./src/js/components/settings/billing-details.jsx